(function () {
  if (window.__productSectionReviews) return;
  window.__productSectionReviews = true;

  function text(node) {
    if (!node) return '';
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function stars(score) {
    var count = parseInt(score, 10);
    if (!count || count < 1) count = 5;
    if (count > 5) count = 5;
    return '★★★★★'.slice(0, count);
  }

  function element(tag, className, value) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (value) node.textContent = value;
    return node;
  }

  function init(root) {
    if (!root || root.dataset.bound === 'true') return;
    var source = root.querySelector('template[data-reviews-source]');
    var grid = root.querySelector('[data-reviews-grid]');
    if (!source || !grid || !source.content) return;

    var reviews = source.content.querySelectorAll('.jdgm-rev');
    if (!reviews.length) return;

    var limit = parseInt(root.dataset.reviewLimit, 10);
    if (!limit || limit < 1) limit = 6;
    var verifiedLabel = root.dataset.verifiedLabel || '';
    var fragment = document.createDocumentFragment();
    var shown = 0;

    reviews.forEach(function (review) {
      if (shown >= limit) return;
      var content = review.querySelector('.jdgm-rev__content');
      var body = text(content && content.querySelector('.jdgm-rev__body'));
      if (!body) {
        body = text(content && content.querySelector('.jdgm-rev__title'));
      }
      if (!body) return;

      var name = text(review.querySelector('.jdgm-rev__author'));
      var location = text(review.querySelector('.jdgm-rev__location')).replace(/[()]/g, '').trim();
      var rating = review.querySelector('.jdgm-rev__rating');
      var meta = [];
      if (review.getAttribute('data-verified-buyer') === 'true' && verifiedLabel) meta.push(verifiedLabel);
      if (location) meta.push(location);

      var item = element('blockquote', 'product-section-reviews__item');
      item.appendChild(element('p', 'product-section-reviews__item-stars', stars(rating && rating.getAttribute('data-score'))));
      item.appendChild(element('p', 'product-section-reviews__body', body));

      var author = element('footer', 'product-section-reviews__author');
      var avatar = element('span', 'product-section-reviews__avatar', name.charAt(0));
      avatar.setAttribute('aria-hidden', 'true');
      author.appendChild(avatar);

      var byline = element('span');
      if (name) byline.appendChild(element('span', 'product-section-reviews__name', name));
      if (meta.length) byline.appendChild(element('span', 'product-section-reviews__loc', meta.join(' · ')));
      author.appendChild(byline);
      item.appendChild(author);
      fragment.appendChild(item);
      shown += 1;
    });

    if (!shown) return;
    grid.textContent = '';
    grid.appendChild(fragment);

    var summary = source.content.querySelector('.jdgm-rev-widg');
    if (summary) {
      var average = summary.getAttribute('data-average-rating');
      var count = summary.getAttribute('data-number-of-reviews');
      var averageNode = root.querySelector('.product-section-reviews__avg');
      var countNode = root.querySelector('.product-section-reviews__count');
      if (average && averageNode) averageNode.textContent = average;
      if (count && countNode) countNode.textContent = countNode.textContent.replace(/\d[\d,]*/, count);
    }

    root.dataset.bound = 'true';
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-section-reviews]').forEach(init);
  }

  boot();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
